import { render, staticRenderFns } from "./trigger-with-menu.vue?vue&type=template&id=988b1e70&scoped=true&"
import script from "./trigger-with-menu.vue?vue&type=script&setup=true&lang=js&"
export * from "./trigger-with-menu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./trigger-with-menu.vue?vue&type=style&index=0&id=988b1e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b1e70",
  null
  
)

export default component.exports